import { Routes, Route, Navigate } from 'react-router-dom';
import routes from 'routes';

export default function PublicLayout() {
    const getRoutes = (routes: any[]): any => {
        return routes.map((route: any, key: any) => {
            if (route.layout === '/public') {
                return (
                    <Route path={`/${route.path}`} element={route.component} key={key} />
                );
            }
            if (route.collapse) {
                return getRoutes(route.items);
            }
            if (route.category) {
                return getRoutes(route.items);
            } else {
                return null;
            }
        });
    };

    return (
        <Routes>
            {getRoutes(routes)}
            <Route path="/" element={<Navigate to="/public/lead-form" replace />} />
        </Routes>
    );
}
